import {
  computeLeafMass,
  computeWoodMass,
  computeRootMass,
} from "./carbonCalcs";

function Popup(props) {
  const { trees, cutlines, coords } = props;
  let Area, NDVI;
  trees[0] && ({ Area, NDVI } = trees[0].properties);
  let imgDate;
  if (cutlines.length) {
    imgDate = new Date(cutlines[0].properties.ACQDATE).toLocaleString(
      "default",
      {
        dateStyle: "medium",
      }
    );
  }

  // Calculate carbon sequestration using new functions
  const leafCarbon = computeLeafMass(Area) * 0.47;
  const woodCarbon = computeWoodMass(Area) * 0.47;
  const rootCarbon = computeRootMass(Area) * 0.47;
  const totalCarbon = leafCarbon + woodCarbon + rootCarbon;

  return (
    <div className="popup-styled">
      <div className="popup-column">
        <div className="popup-row">
          {cutlines.length !== 0 && (
            <div className="popup-item-single date">
              <div className="popup-text">{imgDate}</div>{" "}
              <div className="popup-title">Source image date</div>
            </div>
          )}
        </div>
        {trees.length !== 0 && (
          <>
            <div className="popup-row row-one">
              <div className="popup-item-triple">
                <div className="popup-text">
                  {rootCarbon.toFixed(0)}
                  <span className="popup-unit"> kg</span>
                </div>
                <div className="popup-title">Root carbon</div>
              </div>

              <div className="popup-item-triple">
                <div className="popup-text">
                  {woodCarbon.toFixed(0)}
                  <span className="popup-unit"> kg</span>
                </div>
                <div className="popup-title">Wood carbon</div>
              </div>

              <div className="popup-item-triple">
                <div className="popup-text">
                  {leafCarbon.toFixed(1)}
                  <span className="popup-unit"> kg</span>
                </div>
                <div className="popup-title">Leaf carbon</div>
              </div>
            </div>

            <div className="popup-row">
              <div className="popup-item-single total">
                <div className="popup-text">
                  {totalCarbon.toFixed(0)}
                  <span className="popup-unit"> kg</span>
                </div>
                <div className="popup-title">Total carbon</div>
              </div>
            </div>
            <div className="popup-row row-two">
              <div className="popup-item-triple">
                <div className="popup-text">
                  {coords[0].toFixed(5)}, {coords[1].toFixed(5)}
                </div>
              </div>
              <div className="popup-item-triple">
                <div className="popup-text">{NDVI.toFixed(2)}</div>
                <div className="popup-title">NDVI</div>
              </div>
              <div className="popup-item-triple">
                <div className="popup-text">
                  {Area.toFixed(1)}
                  <span className="popup-unit">
                    {" "}
                    m<sup>2</sup>
                  </span>
                </div>
                <div className="popup-title">Area</div>
              </div>
            </div>
          </>
        )}
        {cutlines.length !== 0 && (
          <div className="popup-row">
            <div className="popup-item-single preview">
              <a
                target="_blank"
                rel="noreferrer"
                href={
                  "https://api.discover.digitalglobe.com/show?id=" +
                  cutlines[0].properties.CAT_ID
                }
              >
                <div className="popup-text">
                  Preview source imagery
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQElEQVR42qXKwQkAIAxDUUdxtO6/RBQkQZvSi8I/pL4BoGw/XPkh4XigPmsUgh0626AjRsgxHTkUThsG2T/sIlzdTsp52kSS1wAAAABJRU5ErkJggg=="
                    alt="external link"
                  ></img>
                </div>

                <div className="popup-title">
                  © Maxar{" "}
                  {new Date(cutlines[0].properties.ACQDATE).getFullYear()}
                </div>
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default Popup;
